import { render, staticRenderFns } from "./PurchaseEdit.vue?vue&type=template&id=2d36d386"
import script from "./PurchaseEdit.vue?vue&type=script&lang=ts"
export * from "./PurchaseEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports